import React, { FC } from 'react';
import Container from '../../../../../Common/Container/Container';
import AccordionList from '../../../Components/AccordionList/AccordionList';
import * as classes from './ServicesSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Tabs from '../../../Components/Tabs/Tabs';
import Tab from '../../../../../Common/Tab/Tab';
import ServiceInfo from '../../../Components/ServiceInfo/ServiceInfo';
import cn from 'classnames';
import Section from '../../../Components/Section/Section';
import { ServicesSectionProps } from '../../../../../Sections/HomePage/ServicesSection/ServicesSection';
import DefaultButton from '../../../Components/DefaultButton/DefaultButton';

const ServicesSection: FC<ServicesSectionProps> = ({ services, activeServiceId, setActiveService }) => {
  const { t } = useTranslation();

  const informationRequestButton = (
    <DefaultButton
      link={{
        title: t('homePage.servicesSection.informationRequestButton.linkTitle'),
        path: t('homePage.servicesSection.informationRequestButton.buttonLink'),
      }}
    >
      {t('homePage.servicesSection.informationRequestButton.buttonText')}
    </DefaultButton>
  );

  const tabsButton = <div className={classes.buttonWrapper}>{informationRequestButton}</div>;

  const afterComponent = (
    <div>
      <div>{t('homePage.servicesSection.servicesAnnotation')}</div>
      <div className={classes.accordionButtonWrapper}>{informationRequestButton}</div>
    </div>
  );

  return (
    <Section number={'02'} label={t('homePage.servicesSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className={'d-md-none'}>
          <AccordionList activeIds={activeServiceId} items={services} action={setActiveService} itemAfterComponent={afterComponent} />
        </div>
        <div className={'d-md-block d-none'}>
          <Tabs isVertical contentAfterHeader={tabsButton}>
            {services.map(item => {
              const specialties = [...item.specialties.map(item => item.title), ...item.customSpecialties];
              const benefits = [...item.helps.map(it => it.title), ...item.customHelps];
              // if (item.sector?.benefits?.length) {
              //   benefits = [...benefits, ...item.sector.benefits];
              // }
              return (
                <Tab key={item.id} label={item?.sector?.title || item.customSector} id={item.id}>
                  <ServiceInfo
                    specialties={specialties}
                    helps={benefits}
                    appointmentTypes={item.appointmentTypes.concat(
                      item.customAppointmentTypes.map((item, index) => ({ title: item, id: index.toString() })),
                    )}
                    year={item.experience.year}
                    hiddenYear={item.experience.hideOnSite}
                  />
                </Tab>
              );
            })}
          </Tabs>
          <div className={'row'}>
            <div className={cn(classes.servicesAnnotation, 'col-md-8 col-lg-7 offset-md-4 offset-lg-5')}>
              {t('homePage.servicesSection.servicesAnnotation')}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default ServicesSection;
